/** @format */
import { createStore, applyMiddleware, compose } from 'redux';
import reducers from './reducers';
import thunk from 'redux-thunk';
import throttle from 'lodash/throttle';
import { storage } from '../src/constants'

function saveToLocalStorage(state) {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(storage.POSTCODE_REDUX_STATE, serializedState);
    } catch (error) {
        console.error(error);
    }
}

function loadFromLocalStorage() {
    try {
        const serializedState = localStorage.getItem(storage.POSTCODE_REDUX_STATE);
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (error) {
        console.error(error);
        return undefined;
    }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistedState = loadFromLocalStorage();
const store = createStore(reducers, persistedState, composeEnhancers(applyMiddleware(thunk)));
store.subscribe(
    throttle(
        () =>
            saveToLocalStorage(store.getState()),
        1000
    )
);

export default store;
